import React, { useEffect, useState } from "react";
import "./JuryAssignment.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../TopBar/TopBar";
import {
  CreateButton,
  GreyBackgroundButton,
  GreyBorderButton,
  GreyfilterButton,
  RedBackgroundButton,
  RedBordButton,
  ViewMoreButton,
} from "../../../Global/GlobalButton";
import { useNavigate } from "react-router-dom";
import { DescriptionContent, GreenContent, RedContent, SubHeading } from "../../../Global/GlobalText";
import { IoMdAddCircleOutline, IoMdClose } from "react-icons/io";
import { IoLockClosedSharp, IoLockOpenSharp, IoMail, IoSearchSharp } from "react-icons/io5";
import { LuFilter } from "react-icons/lu";
import { GlobalSecondTable } from "../../../Global/GlobalSecondTable/GlobalSecondTable";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { MdCreditScore, MdEditSquare } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import {
  CheckboxInput,
  InputLabel,
  InputType,
} from "../../../Global/GlobalFormElement";
import Modal from "react-bootstrap/Modal";
import { EXCHNAGE_URL, EXCHNAGE_URL_JUDGE } from "../../../../Url/Url";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLoading } from "../../../LoadingContext"; // ✅ ADD THIS

export const JuryAssignment = () => {
  const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader

  const [selectedRows, setSelectedRows] = useState([]);
  const [show, setShow] = useState(false);
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const [juryData, setJuryData] = useState([]);
  const [roundData, setRoundData] = useState([]);
  const [selectedRound, setSelectedRound] = useState(null); 
  const [roundId, setRoundId] = useState(null); 
  const [roundName, setRoundName] = useState("");
  const [selectedJuryData, setSelectedJuryData] = useState(null); 
  const [selectedData, setSelectedData] = useState([]); 
  const [refetchJuryData, setRefetchJuryData] = useState(false); 
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isDropdownVisibleForJuryGroup, setIsDropdownVisibleForJuryGroup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [judgeData, setJudgeData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const navigate = useNavigate();

  const initialEventId = String(eventIdGet);
  console.log("rpundId", roundId)
  const [formData, setFormData] = useState({
    group_name: [],
    email: "",
    first_name: "",
    last_name: "",
    is_readonly: 0,
    is_auto_signin: 0,
    is_assign_New: 0,
    is_assign_close: 0,
    is_assign_send: 0,
  });


  const columns = [
    { label: "Name", accessor: "Name" },
    { label: "Email", accessor: "Email" },
    { label: "Assignment Group", accessor: "Assignment Group" },
    { label: "Status", accessor: "Status" },
    { label: "Actions", accessor: "Actions" },
  ];
  const message = "Please select a particular round to see the jury assignment data"
 
  const resetFormData = () => {
    setFormData({
      group_name: [],
      email: "",
      first_name: "",
      last_name: "",
      is_readonly: false,
      is_auto_signin: false,
    });
  };
  


  const handleJuryGroupChange = (group_name) => {
    if (formData.group_name.includes(group_name)) {

      setFormData({
        ...formData,
        group_name: formData.group_name.filter((item) => item !== group_name),
      });
    } else {

      setFormData({
        ...formData,
        group_name: [...formData.group_name, group_name],
      });
    }
    setIsDropdownVisibleForJuryGroup(false);
  };
  const handleRemoveJuryGroup = (group_name) => {
    setFormData({
      ...formData,
      group_name: formData.group_name.filter((item) => item !== group_name),
    });
  };

  const toggleDropdown = () => {
    setIsDropdownVisibleForJuryGroup(!isDropdownVisibleForJuryGroup);
  };

  
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const token = localStorage.getItem("token");

  

  const [errors, setErrors] = useState({
    email: "",
    first_name: "",
    last_name: "",
  });

  const validateForm = () => {
    const { email, firstName, lastName } = formData;
    let isValid = true;
    const validationErrors = {};

    if (!email) {
      validationErrors.email = "Email is required";
      isValid = false;
    }
    if (!firstName) {
      validationErrors.firstName = "First name is required";
      isValid = false;
    }
    if (!lastName) {
      validationErrors.lastName = "Last name is required";
      isValid = false;
    }

    setErrors(validationErrors);
    return isValid;
  };

  
    const setSelectedRow = (row) => {  
      console.log("Selected row:", row);
    };





  //   // debugger
  // const handleSubmitJuryAssignment = async (e) => {
  //       e.preventDefault();  // ✅ Add this

  //     if (!roundId) {
  //       toast.error("Please select a round first.");
  //       return;
  //     }
    
  //     if (isSubmitting) return;
    
  //     setIsSubmitting(true);
  //         setLoading(true); // ✅ Start global loader

      
  //     const { group_name, email, first_name, last_name, is_readonly, is_auto_signin, is_assign_New, is_assign_close, is_assign_send } = formData;
    
  //     const requestData = {
  //       round_name:roundName,
  //       roundId: roundId,
  //       eventId: initialEventId,
  //       group_name: group_name,
  //       email,
  //       first_name: first_name,
  //       last_name: last_name,
  //       is_readonly: is_readonly ? 1 : 0,
  //       is_auto_signin: is_auto_signin ? 1 : 0,
  //       is_assign_New: formData.is_assign_New ? 1 : 0,
  //       is_assign_close: formData.is_assign_close ? 1 : 0,
  //       is_assign_send: formData.is_assign_send ? 1 : 0,
  //     };
    
  //     try {
  //       const response = await axios.post(
  //         `${EXCHNAGE_URL}/assignJury`,
  //         requestData,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       console.log("Jury assigned successfully:", response.data);
  //       toast.success("Jury Assigned Successfully");
    
  //       setIsSubmitting(false);
  //       setRefetchJuryData(true); 
  //       resetFormData()
  //     } catch (error) {
  //       console.error("Error assigning jury:", error);
  //       setIsSubmitting(false); 
  //     } finally {
  //       setIsSubmitting(false);
  //       setLoading(false); // ✅ Stop global loader
  //     }
  //   };

  
  const handleSubmitJuryAssignment = async (e) => {

  if (!roundId) {
    toast.error("Please select a round first.");
    return;
  }

  if (isSubmitting) return;

  setIsSubmitting(true);
  setLoading(true); // ✅ Start global loader

  const { group_name, email, first_name, last_name, is_readonly, is_auto_signin, is_assign_New, is_assign_close, is_assign_send } = formData;

  const requestData = {
    round_name: roundName,
    roundId: roundId,
    eventId: initialEventId,
    group_name: group_name,
    email,
    first_name: first_name,
    last_name: last_name,
    is_readonly: is_readonly ? 1 : 0,
    is_auto_signin: is_auto_signin ? 1 : 0,
    is_assign_New: formData.is_assign_New ? 1 : 0,
    is_assign_close: formData.is_assign_close ? 1 : 0,
    is_assign_send: formData.is_assign_send ? 1 : 0,
  };

  try {
    const response = await axios.post(
      `${EXCHNAGE_URL}/assignJury`,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Jury assigned successfully:", response.data);
    toast.success("Jury Assigned Successfully");

    setRefetchJuryData(true);
    resetFormData();
    setShow(false); // ✅ Added - close modal on success
  } catch (error) {
    console.error("Error assigning jury:", error);
    toast.error("Failed to assign jury");
  } finally {
    setIsSubmitting(false); // ✅ Only once in finally
    setLoading(false); // ✅ Stop global loader
  }
};
    const handleAssignNew = () => {
      setFormData({
        ...formData,
        is_assign_New: 1,
        is_assign_close: 0,
        is_assign_send: 0,
      });
    };
  
    const handleAssignClose = () => {
      setFormData({
        ...formData,
        is_assign_New: 0,
        is_assign_close: 1,
        is_assign_send: 0,
      });
    };
  
    const handleAssignSend = () => {
      setFormData({
        ...formData,
        is_assign_New: 0,
        is_assign_close: 0,
        is_assign_send: 1,
      });
    };
    
  const handleUpdateJuryAssignment = async (e) => {
    
         setLoading(true); // ✅ Start global loader

    const { group_name, email, first_name, last_name, is_readonly, is_auto_signin, is_assign_New, is_assign_close, is_assign_send } = formData;
    
    const requestData = {
      juryAssignId:formData.juryAssignId,
      roundId: roundId,
      eventId: initialEventId,
      group_name: group_name,
      email,
      first_name: first_name,
      last_name: last_name,
      is_readonly: is_readonly ? 1 : 0,
      is_auto_signin: is_auto_signin ? 1 : 0,
      is_assign_New: is_assign_New ? 1 : 0,
      is_assign_close: is_assign_close ? 1 : 0,
      is_assign_send: is_assign_send ? 1 : 0,
    };
  

    try {
      const response = await axios.put(
        `${EXCHNAGE_URL}/assignJury?juryAssignId=${formData.juryAssignId}`,  
        requestData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log("Jury assignment updated successfully:", response.data);
      toast.success("Jury assignment updated successfully!");
      setRefetchJuryData(true);
      resetFormData();
      setIsEditMode(false);
      setShow(false); 
    } catch (error) {
      console.error("Error updating jury assignment:", error);
      toast.error("Failed to update jury assignment!");
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };

  const handleEditClick = async (juryAssignId) => {
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/assignJury?eventId=${initialEventId}&roundId=${roundId}&juryAssignId=${juryAssignId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      const juryData = response.data.data;
      console.log("Jury data for selected assignment:", juryData);
      toast.success("Jury data fetched successfully!");
  
      setFormData({
        juryAssignId: juryData.juryAssignId || "",
        eventId: juryData.eventId,
        roundId: juryData.roundId,
        group_name: juryData.group_names || [],
        email: juryData.email || "",
        first_name: juryData.first_name || "",
        last_name: juryData.last_name || "",   
        is_readonly: juryData.is_readonly || 0,
        is_auto_signin: juryData.is_auto_signin || 0,
      });
      setIsEditMode(true); 
      setShow(true);
    } catch (error) {
      console.error("Error fetching jury data:", error);
      toast.error("Failed to fetch jury data!");
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };

  const handleDeleteJuryAssignment = async (juryAssignId) => {
        setLoading(true); // ✅ Start global loader

      try {
        const response = await axios.delete(
          `${EXCHNAGE_URL}/assignJury?eventId=${initialEventId}&roundId=${roundId}&juryAssignId=${juryAssignId}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
  
        console.log("Jury assignment deleted successfully:", response.data);
        toast.success("Jury assignment deleted successfully!");
        setJuryData(prevData => prevData.filter(jury => jury.juryAssignId !== juryAssignId));

        setRefetchJuryData(true);
      } catch (error) {
        console.error("Error deleting jury assignment:", error);
        toast.error("Failed to delete jury assignment!");
      } finally {
      setLoading(false); // ✅ Stop global loader
    }

  };
  useEffect(() => {
    if (roundId) {
      const fetchAllJuryAssignment = async () => {
                setLoading(true); // ✅ Start global loader

        try {
          const response = await axios.get(`${EXCHNAGE_URL}/allAssignJury?eventId=${initialEventId}&roundId=${roundId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          const allJuryData = response.data.data;
          setJuryData(allJuryData);
        } catch (error) {
          console.log(error);
        }finally {
          setLoading(false); // ✅ Stop global loader
        }
      };
      fetchAllJuryAssignment();
    }
  }, [roundId, initialEventId, token, refetchJuryData]);

  useEffect(() => {
    const fetchRounds = async () => {
            setLoading(true); // ✅ Start global loader

      try {
        const response = await axios.get(`${EXCHNAGE_URL}/listOfRounds?eventId=${initialEventId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const roundData = response.data.data;
        setRoundData(roundData);
      } catch (error) {
        console.log(error);
      }finally {
        setLoading(false); // ✅ Stop global loader
      }

    };
    fetchRounds();
  }, [initialEventId, token]);

  const handleNavigate = (roundId) => {
    navigate(`/update-jury-post/${roundId}`);
  };

  const handleRoundClick = (round) => {
    setSelectedRound(round); 
    toast.success("Round selected Successfully")
    setRoundId(round.roundId); // Set the roundId for further API calls
    setRoundName(round.round_name)

    setIsDropdownVisible(false);
    fetchJuryGroup(initialEventId, round.roundId)
  };




  const fetchJuryGroup = async (initialEventId, roundId) => {
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/getaljudge?eventId=${initialEventId}&roundId=${roundId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token if required
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('API Response:', response.data);
      setJudgeData(response.data.data); // Assuming `data` holds your desired info
    } catch (error) {
      console.error('Error fetching Jury Group:', error);
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };



  const handleClose = () => 
    { 
       setShow(false);
       setIsEditMode(false);
       resetFormData();
    }
  const handleShow = () => setShow(true);


  const handleCheckboxChangeTable  = (rowId, checked) => {
    const selectedRow = juryData.find((row) => row.juryAssignId === rowId);
    if (checked) {
      setSelectedData((prevSelectedData) => [
        ...prevSelectedData,
        {
          email: selectedRow.email,
          first_name: selectedRow.first_name,
          last_name: selectedRow.last_name,
        },
      ]);
    } else {
      setSelectedData((prevSelectedData) =>
        prevSelectedData.filter((data) => data.email !== selectedRow.email)
      );
    }
    if (checked) {
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowId]);
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((id) => id !== rowId)
      );
    }
  };
  
  const sendInvitation = async () => {

    const sendData = {
         round_name:roundName,
         roundId: roundId,
         eventId: initialEventId,
         data:selectedData,
    }
        setLoading(true); // ✅ Start global loader

    try {
      if (selectedData.length === 0) {
        alert("Please select at least one jury member.");
        return;
      }
      const response = await axios.post(
        `${EXCHNAGE_URL}/send-bulk-emails`, 
        sendData,     
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('Invitation sent successfully:', response.data);
      toast.success("Invitation sent successfully!");
    } catch (error) {
      console.error('Error sending invitation:', error);
      toast.error("Failed to send invitation. Please try again.");
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };

  const handleLockJuryAssignment = async (juryAssignId) => {
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.post(`${EXCHNAGE_URL_JUDGE}/lock-jury`, {
        juryAssignId,         
        roundId,
        eventId: initialEventId,  
      });
  
      console.log('Jury locked successfully', response.data);
      toast.success("Jury locked successfully!");
      setJuryData(prev =>
        prev.map(jury =>
          jury.juryAssignId === juryAssignId ? { ...jury, is_locked: 1 } : jury
        )
      );

    } catch (error) {
      console.error('Error locking jury:', error);
      toast.error("Failed to lock jury.");
    } finally {
      setLoading(false); // ✅ Stop global loader
    }
  };

  const handleCofirmbuttonUpdate = async (juryAssignId) => {
        setLoading(true); // ✅ Start global loader

    try {
    const response = await axios.post(`${EXCHNAGE_URL_JUDGE}/reset-confirm-score`, {
        judgeId:juryAssignId,        
        roundId,
        eventId: initialEventId,
      });
  
      console.log('Eamil Send successfully', response.data);
         toast.success("Jury Update Confirm button!");
      

    } catch (error) {
      console.error('Error locking jury:', error);
      toast.error("Failed to lock jury.");
    } finally {
      setLoading(false); // ✅ Stop global loader
    }
  };

  const handleUnLockJuryAssignment = async (juryAssignId) => {
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.put(`${EXCHNAGE_URL_JUDGE}/unlock-jury`, {
        juryAssignId,        
        roundId,
        eventId: initialEventId,
      });
  
      console.log('Jury locked successfully', response.data);
      toast.success("Jury locked successfully!");
      setJuryData(prev =>
        prev.map(jury =>
          jury.juryAssignId === juryAssignId ? { ...jury, is_locked: 0 } : jury
        )
      );
    } catch (error) {
      console.error('Error locking jury:', error);
      toast.error("Failed to lock jury.");
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };
  
  const HandleemailSendonEmail = async (juryAssignId) => {
         setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.post(`${EXCHNAGE_URL_JUDGE}/send-judge-score-pdf`, {
        judgeId:juryAssignId,        
        roundId,
        eventId: initialEventId,
      });
  
      console.log('Eamil Send successfully', response.data);
      toast.success("Eamil Send successfully!");
     
    } catch (error) {
      console.error('Error locking jury:', error);
      toast.error("Failed to lock jury.");
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };
 const data = juryData.map((jury) => {
  const scored = jury.totalScoredByJudge || 0;
  const total = jury.totalShortlistSubmissions || 0;

  let scoringText = "";
  let scoringColor = "";

  if (total === 0) {
    scoringText = "No Submissions";
    scoringColor = "#999"; // gray
  } else if (scored === 0) {
    scoringText = "Not Started";
    scoringColor = "#e74c3c"; // red
  } else {
    scoringText = `Scored ${scored} / ${total}`;
    scoringColor = "#2ecc71"; // green
  }
  return {
    rowId: jury.juryAssignId, 
    Name: `${jury.first_name} ${jury.last_name}`,
    Email: jury.email,
    "Assignment Group": jury.group_names && Array.isArray(jury.group_names) 
      ? jury.group_names.join(", ")
      : "No Group",
 Status: (
  <span style={{
    backgroundColor: scoringColor,
    color: "#fff",
    padding: "4px 10px",
    borderRadius: "12px",
    fontWeight: 500,
    display: "inline-block",
    minWidth: "100px",
    textAlign: "center"
  }}>
    {scoringText}
  </span>
),
   Actions: (
      <div style={{ color: "#777777", cursor: "pointer", marginLeft: "20px" }}>
        <FaArrowRotateLeft />
        <MdEditSquare onClick={() => handleEditClick(jury.juryAssignId)} />
        <RiDeleteBin6Fill onClick={() => handleDeleteJuryAssignment(jury.juryAssignId)} />
        {jury.is_locked === 0 ? (
          <IoLockClosedSharp
            onClick={() => handleLockJuryAssignment(jury.juryAssignId)}
            style={{ marginLeft: "10px", cursor: "pointer", color: "#f4c542" }}
            title="Click to lock jury"
          />
        ) : (
          <IoLockOpenSharp
            onClick={() => handleUnLockJuryAssignment(jury.juryAssignId)}
            style={{ marginLeft: "10px", cursor: "pointer", color: "#4287f5" }}
            title="Click to unlock jury"
          />

        )}
        <MdCreditScore
         onClick={() => HandleemailSendonEmail(jury.juryAssignId)}
            style={{ marginLeft: "10px", cursor: "pointer", color: "#4287f5" }}
            title="Click Send Judge Score on Judge Email"
         />

         <IoMail 

           onClick={() => handleCofirmbuttonUpdate(jury.juryAssignId)}
            style={{ marginLeft: "10px", cursor: "pointer", color: "#4287f5" }}
            title="Click to Send Email"
         />
      </div>
    
    ),
  };
});

console.log("Jury Data:", data);
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (formData.juryAssignId) {
      handleUpdateJuryAssignment();
    } else {
      handleSubmitJuryAssignment();
    }
  };

  const handleExportCsv = async () => {
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/AssignJuryData?eventId=${eventIdGet}&roundId=${roundId}`,
        {
          responseType: 'blob',
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'AssignJuryData.xlsx'); 
      document.body.appendChild(link)
;
      link.click();
      document.body.removeChild(link)
      toast.success("Data downloded SuccessFully")
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // ✅ Stop global loader
    }
  };
  

   
  const JuryGroupOptions = [
    "All Shortlisted Submissions", 
    ...judgeData.map((item) => item.name)
  ];

  const formatDateTime = (date, time) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();

    return `${day} ${month} ${year} ${time}`;
  };

  
  return (
    <div>
      
      <div className="jury_assignment_data_div">
        <TitleBar title="Jury Assignment" />
        <div className="jury_assignment_white_bg">
          {/* <TopBar titleheading="Jury Assignment" /> */}
          <div className="jury_assign_round_btn">
            <div className="newBtn">

              <div>
                <button
                  className="Bt"
                onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
                  {isDropdownVisible ? 'Hide Rounds' : 'Show Rounds'}
                </button>

                {isDropdownVisible && (
                  <div
                  className={`dropdown-container ${isDropdownVisible ? "show" : ""}`}
                  >
                    {roundData.length !== 0 ? (
                      roundData.map((round, index) => (
                        <div
                          key={round.roundId}
                          className="round-button-container"
                          style={{ marginBottom: '1rem' }}
                        >
                          <CreateButton className="Btt" onClick={() => handleRoundClick(round)}>
                            {round.round_name}
                          </CreateButton>
 {round.is_active === 1 ? (
        <GreenContent>Active</GreenContent>
      ) : (
        <RedContent>Unactive</RedContent>
      )}                        </div>
                      ))
                    ) : (
                      <div>No rounds available</div>
                    )}
                  </div>
                )}
              </div>

              {selectedRound && (
                <div className="round-details">
                  <CreateButton>
                    {selectedRound.round_name} 
                  </CreateButton>
                  {/* <GreenContent>Active</GreenContent> */}
                </div>
              )}
            </div>
          </div>

          <div className="jury_assignment_date_div">
            {selectedRound && (
                           <DescriptionContent>
                           From {formatDateTime(selectedRound.start_date, selectedRound.start_time)} to{" "}
                           {formatDateTime(selectedRound.end_date, selectedRound.end_time)}
                         </DescriptionContent>
                          )}

            <RedBordButton
              className="jury_assignment_pluscontent"
              onClick={handleShow}
              disabled={!selectedRound} 
            >
              <IoMdAddCircleOutline />
              Assign Jury to This round
            </RedBordButton>
          </div>

          <div className="jury_assignment_table_div">
            <div className="jury_assignment_table_search">
              <div className="jury_assignment_table_icon">
                <IoSearchSharp />
              </div>
              <div className="jury_assignment_table_icon_content">
                <input type="text" placeholder="Search here..." />
              </div>
            </div>
            <div className="jury_assignment_filter_btn">
              <ViewMoreButton style={{ color: "#333333" }}
              type="button"
              onClick={handleExportCsv}
              >
                Export CSV
              </ViewMoreButton>

              <RedBordButton style={{ fontSize: "16px" }} onClick={sendInvitation} >
                Send Invitation
              </RedBordButton>

              <GreyfilterButton className="jury_assignment_filter_icon">
                <LuFilter />
                Filter
              </GreyfilterButton>
            </div>
          </div>

          <GlobalSecondTable
            data={data}
            columns={columns}
            selectedRows={selectedRows} // Ensure this is always an array
            onCheckboxChange={handleCheckboxChangeTable}
            onRowClick={setSelectedRow}
          />
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Add Jury Assignment</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Jury Assign */}
    <div className="juryassign_cont">
      <div className="juryassign_heading">
        <SubHeading>Assign Jury to round 1</SubHeading>
      </div>

      <form className="juryassign_form" onSubmit={handleFormSubmit}>
       
<div className="juryassign_row">
  <InputLabel>Jury Group</InputLabel>
  <InputType
    name="group_name"
    value={formData.group_name ? formData.group_name.join(", ") : ""}
    onChange={handleJuryGroupChange}
    readOnly
    onClick={toggleDropdown} // Show dropdown on click
    style={{ cursor: "pointer" }}
  />
  
  <div className="selected-industries">
    {formData.group_name.map((group_name, index) => (
      <div key={index} className="selected-industry-item">
        <span>{group_name}</span> {/* Display the name of the selected group */}
        <IoMdClose
          className="remove-icon"
          onClick={() => handleRemoveJuryGroup(group_name)} // Remove the group on click
        />
      </div>
    ))}
  </div>

  {isDropdownVisibleForJuryGroup && (
    <div className="dropdown">
      {JuryGroupOptions.map((group_name, index) => (
        <div
          key={index}
          className={`dropdown-option ${formData.group_name.includes(group_name) ? "selected" : ""}`}
          onClick={() => handleJuryGroupChange(group_name)}
          style={{
            cursor: "pointer",
            backgroundColor: formData.group_name.includes(group_name) ? "#e0e0e0" : "white",
            pointerEvents: formData.group_name.includes(group_name) ? "none" : "auto",
          }}
        >
          {group_name}
        </div>
      ))}
    </div>
  )}
</div>



        <div className="juryassign_row">
          <InputLabel>Email</InputLabel>
          <InputType
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Email"
            disabled={isEditMode}

          />
        </div>

        <div className="juryassign_row">
          <InputLabel>First Name</InputLabel>
          <InputType
            name="first_name"
            value={formData.first_name}
            onChange={handleInputChange}
            placeholder="First Name"
            disabled={isEditMode}

          />
        </div>

        <div className="juryassign_row">
          <InputLabel>Last Name</InputLabel>
          <InputType
            name="last_name"
            value={formData.last_name}
            onChange={handleInputChange}
            placeholder="Last Name"
            disabled={isEditMode}

          />
        </div>

        <div className="juryassign_row">
          <div className="juryassign_check_div">
            <div className="juryassign_label">
              <div className="juryassign_check">
                <div className="juryassign_date">
                  <CheckboxInput
                    name="is_readonly"
                    type="checkbox"
                    checked={formData.is_readonly}
                    onChange={handleCheckboxChange}
                  />
                  <InputLabel>Readonly</InputLabel>
                </div>
              </div>
            </div>
            <div className="juryassign_label">
              <div className="juryassign_check">
                <div className="juryassign_date">
                <CheckboxInput
  name="is_auto_signin"
  type="checkbox"
  checked={true} // Always true
  onChange={() => {}} // Prevent change
/>
                  <InputLabel>Auto Sign In</InputLabel>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="juryassign_btn">
        <GreyBorderButton
  type="submit"
  onClick={() => {
    handleAssignNew();
  }}
  disabled={isSubmitting} 
>
  Assign & Add New
</GreyBorderButton>

<GreyBackgroundButton
  type="submit"
  onClick={() => {
   handleAssignClose();
  }}
  disabled={isSubmitting} 
>
  Assign & Close
</GreyBackgroundButton>

<RedBackgroundButton
  type="submit"
  
  onClick={() => {
  handleAssignSend();
  }}
  disabled={isSubmitting}  
>
  Send Email & Assign Jury
</RedBackgroundButton>

        </div>
      </form>
    </div>
  </Modal.Body>
  <Modal.Footer></Modal.Footer>
</Modal>

    </div>
  );
};
